import { useState, useEffect, useRef, Fragment, memo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./OpenPotList.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import TabList from "./../../comm/global/components/TabList";
import Folder from "./../../comm/global/components/Folder";
import { CustomEventManager } from "../../comm/global/CustomEventManager";
import * as YStyled from "../../Styleds";
import apiManager from '../../ApiManager';
import ImageLoader from "../../comm/global/components/ImageLoader";
import { GameContext } from "../../GameContext";
const customEventManager = new CustomEventManager();
const TabItem = ({ isSelect, data, index, onClick }) => {
    useEffect(() => {
    }, [])
    return (
        <div onClick={e => { onClick(index) }} className={isSelect ? `${styleUi.item} ${styleUi.selected}` : styleUi.item}>
            <span>{data.label}</span>
        </div>
    );
}
const OpenPotList = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [editting, set_editting] = useState(false);
    const [tabSelectId, set_tabSelectId] = useState(0);
    const [selectedPot, set_selectedPot] = useState(-1);
    const [ownerRewildings, set_ownerRewildings] = useState([]);
    const { pocketlist, updatePocketlist } = useContext(GameContext);
    useEffect(() => {
        console.log("OpenPotList", pocketlist);

        setInProp(true);
        fetchAllData();

    }, [])
    useEffect(() => {
        console.log("pocketlist", pocketlist);
    }, [pocketlist])
    async function fetchAllData() {
        try {
            const _ownerRewildings = await apiManager.fetchGet("rewilding", { owner: true }, 10);
            console.log("ownerRewildings", _ownerRewildings)
            set_ownerRewildings(_ownerRewildings)
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }



    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "OpenPotList"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <YStyled.Row align="flex-start" gap=".8rem" style={{ padding: "1rem 1rem 0.5rem 1rem" }}>
                                    <img src="./assets/ui/leftArrow.svg" onClick={e => {
                                        setInProp(false);
                                        /* console.log("listId",pocketlist[1].pocket_lists_id)
                                        console.log("delItems",pocketlist[1].items.slice(0,2))
                                        updatePocketlist("removeListItem",pocketlist[1].pocket_lists_id,pocketlist[1].items.slice(0,2)) */
                                    }} />
                                    {arg.type !== "selPot" &&
                                        <YStyled.Span size={20} fontWeight="500" >己儲存</YStyled.Span>
                                    }
                                </YStyled.Row>
                                {arg.type === "selPot" &&
                                    <YStyled.Span size={20} fontWeight="500" style={{ paddingLeft: "1rem", paddingBottom: "1rem" }} >選取地點加入行程</YStyled.Span>
                                }
                                <div className={styleUi.tab}>
                                    <TabList selectId={tabSelectId} set_selectId={set_tabSelectId} list={[{ label: "清單" }, { label: "己建立" }]} ItemCls={TabItem} clear={false} />
                                </div>
                                {tabSelectId === 0 ?
                                    <div className={styleUi.listPanel}>
                                        {arg.type !== "selPot" &&
                                            <button className={`${allStyle.btnGray3} ${styleUi.newListBtn}`} onClick={e => {
                                                addModalType({
                                                    cls: "NewPotFolder", arg: {
                                                        cb: (newFolder) => {
                                                            updatePocketlist("newList", newFolder);
                                                        }
                                                    }
                                                })

                                            }}>
                                                新增清單
                                            </button>
                                        }
                                        <div className={styleUi.folders}>
                                            {
                                                pocketlist.map((folder, k) => {
                                                    return <Folder key={k} folder={folder} onClick={e => {
                                                        addModalType({
                                                            cls: "ViewFolder", arg: {
                                                                folder: folder,
                                                                type: arg.type,
                                                                cb: () => {
                                                                }
                                                            }
                                                        })
                                                    }} />
                                                })
                                            }
                                        </div>
                                        {arg.type === "selPot" &&
                                            <button disabled={selectedPot === -1} className={styleUi.bottomAdd} onClick={e => {
                                                customEventManager.dispatch("selPot", ownerRewildings[selectedPot]);
                                            }}>
                                                加入行程
                                            </button>
                                        }
                                    </div>
                                    :
                                    <div className={styleUi.exitsPanel}>
                                        {arg.type === "tab0" &&
                                            <span onClick={e => {
                                                set_editting(!editting);
                                            }}>{editting ? "完成" : "編輯"}</span>
                                        }
                                        <div className={styleUi.list}>
                                            {ownerRewildings.map((v, k) => {
                                                return <div key={k} className={`${styleUi.item} ${selectedPot === k ? styleUi.selected : ""}`} >
                                                    <ImageLoader src={(v.rewilding_photos?.length > 0) ? v.rewilding_photos[0].rewilding_photos_path : ''} onClick={e => {
                                                        if (arg.type === "tab0") {
                                                            addModalType({
                                                                cls: "PotDetail", arg: {
                                                                    pot: v
                                                                }
                                                            })
                                                        }
                                                        else {
                                                            set_selectedPot(k);
                                                        }
                                                    }} />
                                                    <YStyled.Span size={17} style={{ paddingTop: ".5rem" }}>{v.rewilding_name}</YStyled.Span>
                                                    <YStyled.Span size={13} color="#6c6c6c" style={{ paddingTop: ".2rem" }}>{v.rewilding_location ? v.rewilding_location.join(" ") : ""}</YStyled.Span>
                                                    {editting &&
                                                        <div className={styleUi.edittingDiv}>
                                                            <div className={styleUi.saveBtn} onClick={e => {
                                                                console.log(v);
                                                                const listids = updatePocketlist("getListIdByRewildId", v.rewilding_id);
                                                                console.log("listids", listids)
                                                                addModalType({
                                                                    cls: "SelFolder", arg: {
                                                                        title: "儲存至",
                                                                        folderId: listids,
                                                                        cb: (folder) => {
                                                                            console.log("folder", folder);
                                                                            apiManager.fetchPost(`pocket-list/${folder.pocket_lists_id}/items`, {
                                                                                "pocket_list_items_rewilding_id": v.rewilding_id
                                                                            }).then(res => {
                                                                                console.log(res);
                                                                                res.pocket_list_items_rewilding_detail = v;
                                                                                updatePocketlist("addItem", folder.pocket_lists_id, res);
                                                                            })
                                                                        }
                                                                    }
                                                                })
                                                            }} >
                                                                <img src="./assets/ui/saveto.svg" />
                                                                <YStyled.Span fontWeight={400} size={15}>儲存至</YStyled.Span>
                                                            </div>
                                                            <img src="./assets/ui/remove.svg" className={`${styleUi.btn}`} onClick={e => {
                                                                addModalType({
                                                                    cls: "AlertCustom", arg: {
                                                                        title: `刪除${v.rewilding_name}？`,
                                                                        desc: "刪除後將無法復原。",
                                                                        options: [
                                                                            {
                                                                                label: "刪除", cb: () => {
                                                                                    apiManager.fetchDelete(`rewilding/${v.rewilding_id}`).then(res => {
                                                                                        console.log(res);
                                                                                        set_ownerRewildings(prev => prev.filter(rewilding => rewilding.rewilding_id !== v.rewilding_id))
                                                                                        //todo 這裡等api修好後，要同步的把pocketlist裡的刪除掉
                                                                                    })
                                                                                }
                                                                            },
                                                                            {
                                                                                label: "取消", cb: () => {

                                                                                }
                                                                            },
                                                                        ],
                                                                    }
                                                                })
                                                            }} />
                                                        </div>
                                                    }
                                                </div>
                                            })}
                                        </div>
                                        {arg.type === "selPot" &&
                                            <button disabled={selectedPot === -1} className={styleUi.bottomAdd} onClick={e => {
                                                customEventManager.dispatch("selPot", ownerRewildings[selectedPot]);
                                            }}>
                                                加入行程
                                            </button>
                                        }
                                    </div>
                                }
                                {arg.type !== "selPot" &&
                                    <IconButton className={styleUi.close} onClick={e => {
                                        setInProp(false)
                                    }}>
                                        <CloseIcon />
                                    </IconButton>
                                }
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(OpenPotList);